import React, { useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Dropdown } from '@hz-design-system/web-ui';

import { TFacet, TFacetOption } from 'types/TCarsSearchFields';

type TCarsSearchFormDropDownProps = {
  fieldKey: string;
  formField?: TFacet;
  value?: string;
  optionalText?: string;
  errorText?: string;
  disabled?: boolean;
  onChangeHandler: Function;
  fixedField?: boolean;
  options?: TFacetOption[];
};

const CarsSearchFormDropDown = ({
  fieldKey,
  formField,
  value,
  optionalText,
  errorText,
  disabled,
  onChangeHandler,
  fixedField,
  options,
}: TCarsSearchFormDropDownProps) => {
  const { t } = useI18nContext();
  const fieldLabel = formField?.label || t(`cars.search.fields.${fieldKey}`);
  const fieldValue = value || '';
  const formFieldOptions = options || formField?.options || [];
  const disabledItem = disabled
    ? [
        {
          label: t('cars.search.options.disabled'),
          value: '',
          disabled,
        },
      ]
    : [];
  const defaultOption = formField?.withAllOption
    ? [
        {
          label: t([`cars.search.options.all_${fieldKey}`, 'cars.search.options.all']),
          value: '',
        },
      ]
    : [];
  const fieldOptions = defaultOption.concat(disabledItem, formFieldOptions);
  const [focus, setFocus] = useState(false);

  if (!formFieldOptions.length && !formField?.optionGroups && !fixedField) {
    return null;
  }

  const onFocusHandler = () => {
    setFocus(!focus);
  };

  return (
    <Dropdown
      id={fieldKey}
      labelText={fieldLabel}
      optionalText={optionalText}
      placeHolderText={!fieldOptions.length || disabled ? t('cars.search.options.all') : ''}
      options={formField?.optionGroups ? defaultOption : fieldOptions}
      optGroups={formField?.optionGroups}
      onChange={(e) => onChangeHandler(fieldKey, e.target.value, formField?.type, true)}
      onFocus={onFocusHandler}
      onBlur={onFocusHandler}
      value={fieldValue}
      errorText={errorText}
      className="FormField"
    />
  );
};

export default CarsSearchFormDropDown;
